(function (window, document, $) {

    $(document).ready(function () {
        // Media queries ===============================================================================================

        var widthXS = 568,
            widthSM = 768,
            widthMD = 1024,
            widthLG = 1280;

        $(window).on('resize', function (e) {

            var is_mobile = false;

            switch (true) {
                case this.matchMedia('(max-width: ' + widthXS + 'px)').matches:
                    // XS
                    is_mobile = true;
                    break;

                case this.matchMedia('(min-width: ' + widthSM + 'px) and (max-width: ' + (widthMD - 1) + 'px)').matches:
                    // SM
                    break;

                case this.matchMedia('(min-width: ' + widthMD + 'px) and (max-width: ' + (widthLG - 1) + 'px)').matches:
                    // MD
                    break;

                case this.matchMedia('(min-width: ' + widthLG + 'px)').matches:
                    // LG
                    break;
            }

            if (!is_mobile && $('.page-wrap').hasClass('d-none')) {
                toggleCheeseBurger(null);
            }
        });
    });

}(window, document, jQuery));
